module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-19"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“I ")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HATE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HER")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v(",")]), _vm._v("” Rayleen groused to no one in particular from her corner table. Somehow, Walker knew he was the one being addressed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked to Jenny, who rolled her eyes. “Charlie was in to sign the lease today,” she explained.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rayleen huffed. “She came in wearing skinny jeans and a big ol’ shit-eating grin. I thought you said she was a nice girl, Walker.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” he asked in honest confusion. “Nice girls don’t wear skinny jeans?” In his opinion, the very nicest girls graced the world with skinny jeans. Tight denim was a gift to all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, they do not. And they certainly don’t walk in here like they own the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rayleen,” Jenny sighed. “Charlie was perfectly kind. You just didn’t like that she didn’t take your bait.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What bait?” the old lady snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I don’t know. What about when you said you’d prefer a Charlie that damn well fit his name, and she just winked and said she’d take a cowboy over her own self any day, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Impertinent.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Kind of like you?” Jenny said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Walker tipped up his hat. “I like a lively lady myself. Why else would I be hanging out in your saloon all the time, Rayleen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe because it’s right next door to your place and you don’t have a damn job!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, now. I’m picking up work and I’ve got plenty lined up for roundup.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rayleen dismissed him with a wave of her hand. “You’re the one who got me into this. I’m not speaking to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you just trying to get me to turn around so you can look at my behind, Miss Rayleen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s a perfect idea. Gives me a nice view and I don’t have to talk to your lying self. Go on. Turn around now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Only ’cause you asked nice.” He turned his back on her and raised his eyebrows to Jenny, who leaned closer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Charlie was great. Rayleen just wanted her to be intimidated, and Charlie met every one of her barbs with a smile and a wink. Sort of like you. Only without the big cowboy part.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Which big cowboy part?” Walker asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re awful.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, now. That’s not what you’ve heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jenny threw her head back and laughed. “You really are incorrigible, Walker.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That I’ll admit to. Is Charlie all settled in? I haven’t seen her yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nate gave her the key a couple of hours ago, and she took the lease to read over. Which Rayleen also didn’t like. She likes you cowboys who just sign the thing without even glancing at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We are adventurers at heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Or romantic fools.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She winked. “Want a beer?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I was just checking in on the new tenant. I heard about some winter work up near Yellowstone, so I’m gonna head up there and check it out. I’m fine through fall, but I’m hoping to find enough work to get me through to spring.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ll find something, Walker. People like your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ha. That they do.” People did like his face, thank God. It was one of the few things he had going for him. Otherwise, he was just another cowboy among thousands. A good one, granted. Good with his hands. Good with horses. Willing to endure heat and cold and snow and rain, not to mention low pay and physically punishing work for fifty years, give or take a dozen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But people liked his face, so he’d been able to get jobs at dude ranches, which offered work that paid a little more and hurt a little less, as long as you didn’t mind working with tourists. He didn’t. But this damn sure wasn’t dude ranch season.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He tipped his hat. “I’ll see you later, Jenny. Have a good day, Miss Rayleen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rayleen shooed him away without looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d get over it, and Charlie had a place to stay. His good deed was done, and he was wrapped up in his own troubles before he even stepped outside.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finding work wasn’t really a problem. He’d already gotten plenty of jobs at an old dude ranch he’d worked for years before, and they’d likely hire him on permanently in the spring. He had enough savings to get through winter. Things should be fine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But if stories were circulating about him and the boss’s wife… Shit. He’d really fucked up. Every boss had a wife. And none of them wanted their women sleeping with the hired hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still, something more than that was tugging at his brain. Maybe—")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His thoughts were sliced in two when he glanced up and saw a woman struggling to get a big round table up the front steps of the Stud Farm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Charlie?” he called, rushing forward to take the table from her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked up, her brown hair sliding over her shoulders as she turned. Her light gray eyes went wide. “Oh, my God! Walker, is that you behind that beard?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s me,” he said with a grin that widened the longer he looked down at her. She was still damn cute. Actually, she’d gone from cute to pretty at some point in the past ten years. “It’s good to see you, Charlie. Can I take this somewhere for you?” He lifted the table a few inches.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shot his hands a look of irritation. “I can’t believe you can just tote that thing around like it’s nothing. I had to roll it like a barrel just to get it across the lawn.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I see that.” He plucked a few clumps of dirt and grass off the table and lifted it up to his shoulder. “Come on. I’ll take it upstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“After you,” he insisted. She held the door open for him, then started up the stairs to the landing above.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Walker followed right behind, noticing that she was obviously still an athlete. Still slim and tight and strong. But not quite as slim as she’d been in high school. No, now there were hips. And an ass. And black leather boots that hugged her calves. And most of all, there were those awesome skinny jeans showing off all the changes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yeah, Charlie was obviously just as nice as she’d always been. But maybe sweeter than ever before.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He glanced at his apartment door as he passed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was certainly much closer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shit. Maybe this good deed wouldn’t go unpunished, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("WEET")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("MOTHER")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OF")]), _vm._v(" everything hot,” Charlie muttered under her breath as she watched Walker Pearce’s biceps flex and bunch as he maneuvered her pine table through the doorway of her apartment. He wore a beat-up gray T-shirt with a Stetson logo on it, tight jeans, ancient boots and a black cowboy hat that threw a shadow over his blue eyes. But that was fine. She didn’t need to see his smiling eyes right now. She was too busy taking in his body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His shoulders hadn’t been that wide in high school. His arms hadn’t been so thick. And he hadn’t been quite that tall. Jesus, he must be six-four now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("All in all, he looked like a dangerous, forbidden, older-brother version of the Walker she’d once had a crush on. Every butterfly she’d ever felt for him swarmed back to life in an instant, only now their restless wings brushed more sensitive areas. There was no reason for her stomach to feel nervous. After all, that wasn’t the part of her body she wanted Walker to touch.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He set the table down close to the breakfast bar in the kitchen. “Is this good?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, that’s definitely good.” She glanced at his left hand to be sure there was no ring. Not that she could imagine Walker married. He’d be a terrible husband. Carefree and aimless and throwing off pheromonal invitations to every ovary in town.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was still trying to take all of him in when his chest suddenly filled her vision and he swept her up into a hug. “How the hell are you, Charlie?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He squeezed her so tight the air rushed out of her lungs. When he set her back down, she inhaled nothing but the scent of him. Leather and hay and clean sky and something so deliciously spicy that her mouth watered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You look good,” he said, holding her at arm’s length and giving her a once-over. “City life has been good to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wanted to say something witty. Something sexy. But for the first time in a decade she was that high school girl again, too shy and uncertain to flirt with Walker Pearce. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What else can I do for you, darlin’? You got a bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” Her cheeks flamed as if her body didn’t want him to know what she’d been thinking. Stupid, brainless body. “A bed?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes, please, a bed!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Surely you didn’t haul a mattress up by yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, a bed!” She laughed nervously while her brain screamed for this retro Charlie to get her shit together. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You are not a sixteen-year-old virgin. You are an experienced woman who likes sex. Lots of sex.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Retro Charlie won out with a tiny giggle. “Thanks, Walker. It’s down in the rental truck. I’ll help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah, you stay here and start unpacking those boxes. I’ll have your bed set up in no time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This was her chance. Crack a joke about hanging around after to test it out. Not that she’d jump into bed with him within minutes of their reunion, but just to let him know it might be a possibility. Just to plant the seed. But no. In the end, she only watched his ass as he walked away. It was a good ass. Strong. Muscular.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ah. This was just like high school. Always watching him from afar even when he was so close.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shit,” she muttered, kicking the box closest to her foot. When she heard the rattle of dishes, she winced and told herself to cut it out. This wasn’t high school, and she’d lived a lot since then. Walker Pearce was no longer too much man for her. And hell, if he was, that’d be her dream come true. A big ol’ cowboy to ride into the sunset. But only into the sunset. Best to keep the mornings a clean slate, especially with a roving boy like Walker.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheered by the thought, Charlie picked up the box she’d kicked and hauled it onto the kitchen counter. When she pried open the flaps and saw the familiar bright yellow of her dinner plates, a weight lifted from her shoulders as if a vulture had just left its vigil. She’d barely moved in and this place already felt more like home than the resort had after three weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d been thrilled with the gorgeous studio apartment set aside for her. It wasn’t normal procedure, but Charlie hadn’t questioned her good luck. She’d just figured that being friends with Dawn, the executive manager of the resort and the wife of the owner, had come with its own perks. Dawn had explained that they wanted a permanent security presence at the resort and left it at that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The offer had been a relief. Now Charlie realized that beautiful apartment had been nothing more than a cage.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Charlie unwrapped her yellow plates and put them precisely in the middle of the lowest shelf next to the stove. “Perfect.” When her brain reminded her she had to be back at the resort by 8:00 a.m., she frowned and dug back into the box. It was just a job.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the sound of boots on the stairs, she looked up to see Walker heading toward her door, her bed frame under one arm and her headboard slung over his other shoulder. He eased his haul through her doorway, then headed for the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her own personal mover.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She followed him in to watch as he propped the slatted wood headboard against the wall, and then she reached to help with the first part of the frame as he fitted it to the wood. “You don’t have to do this, Walker. I can take care of the bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ve been living in Nevada too long if you think a nice Wyoming boy is going to let a woman haul furniture on her own.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She grinned. “I guess you’re right. I’ll have to get used to Wyoming again. More chivalry, less gambling and legalized prostitution.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There are subtle differences, but they’re there if you look.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks for the advice. I’ll put away my poker chips and platform heels and try to fit in.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He winked as he crossed to the other side of the bed and fit a new frame piece onto that side. “There’s no need for anything that drastic, darlin’. Just be yourself. Let it all hang out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She snorted at his ridiculous flirting, just as she always had. There was no way to take it seriously. He flirted with everyone, young and old. She’d always been smart enough to see that. But she was finally ready to flirt back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have any beer in the fridge next door, Walker? There’s no need for this to be all work and no fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He didn’t seem to notice her inviting smile. “Oh, I’ve always got beer, but I’ve got to head up toward Yellowstone for a couple of hours. I’ll grab a couple bottles for you if you want, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I’m good. If you need to get going, you should go. I’m fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Girl, didn’t you hear what I said about us nice Wyoming boys? I’ll have the rest of your bed up here in five minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Girl. Just like in high school. Charlie drew herself up, a tingle of anticipation zinging down her spine and tightening her nipples. She wasn’t a girl anymore. And she wasn’t his pal or his tutor or his favorite tomboy track star. He couldn’t see that yet, but he would.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d always liked a challenge. “Then go get my bed, Wyoming boy. I’ll buy you a beer tonight at the Crooked R if I see you around.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s a deal.” He stepped past her, then surprised her by reaching out to ruffle her hair as he passed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ruffled")]), _vm._v(" her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unbelievable. That decided it. This boy was going down. Hard. And frequently, if she had anything to say about it. She was finally going to get a taste of Walker Pearce. And from what she’d heard, he’d taste damn good.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hadn’t gotten laid in months, and working at a resort that hadn’t even opened yet hadn’t exposed her to many opportunities. But opportunity had knocked now. And it lived right next door.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-16"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a42e56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Two.vue
// module id = 69
// module chunks = 0